type LandingStarIconProps = {
  className?: string;
};

const LandingStarIcon = ({ className }: LandingStarIconProps) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M17.049 7.72177L13.5333 10.7554L14.6044 15.2921C14.6635 15.5384 14.6483 15.7966 14.5607 16.0343C14.4731 16.2719 14.317 16.4782 14.1122 16.6272C13.9074 16.7762 13.663 16.8611 13.4099 16.8713C13.1569 16.8814 12.9065 16.8163 12.6904 16.6843L8.74507 14.2561L4.79741 16.6843C4.58134 16.8156 4.33124 16.88 4.07861 16.8695C3.82599 16.859 3.58212 16.7739 3.37773 16.6251C3.17333 16.4762 3.01755 16.2702 2.92999 16.033C2.84244 15.7958 2.82702 15.538 2.88569 15.2921L3.96069 10.7554L0.445069 7.72177C0.253895 7.55654 0.115635 7.33865 0.0475548 7.09532C-0.0205252 6.85198 -0.0154079 6.59398 0.0622678 6.35354C0.139943 6.11309 0.286735 5.90086 0.48431 5.74335C0.681885 5.58583 0.921487 5.49001 1.17319 5.46786L5.78257 5.09598L7.56069 0.79286C7.65694 0.558342 7.82075 0.357742 8.0313 0.216562C8.24184 0.0753819 8.48962 0 8.74312 0C8.99661 0 9.24439 0.0753819 9.45494 0.216562C9.66548 0.357742 9.82929 0.558342 9.92554 0.79286L11.7029 5.09598L16.3123 5.46786C16.5645 5.48919 16.8048 5.58447 17.0031 5.74177C17.2013 5.89907 17.3488 6.11139 17.427 6.35212C17.5051 6.59286 17.5105 6.85131 17.4424 7.09509C17.3744 7.33886 17.2359 7.55713 17.0443 7.72255L17.049 7.72177Z"
      fill="#DC6803"
    />
  </svg>
);

export default LandingStarIcon;
